import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import VueRouter from 'vue-router'
import App from './App.vue'
import ThirdPage from './views/ThirdPage'
import BlockedPage from './views/BlockedPage'
import {
  buildLandingRoutes,
  createRouteGuard,
  fetchLandingRouteConfig
} from './landingRouteConfig'

Vue.use(VueRouter)
Vue.use(ElementUI)

/**
 * 尽早保存广告参数，并去掉尾斜杠（保留 query）。
 * 避免 Nginx/目录跳转或路由规范化丢掉 callbackid。
 */
function normalizeEntryUrl() {
  try {
    const loc = window.location
    const hash = loc.hash || ''
    let pathname = loc.pathname || '/'
    const params = new URLSearchParams(loc.search)
    const host = String(loc.host || '').toLowerCase()
    const isZt260806Host = host === 'wxvip.yingsi0221.com'
      || host === 'wxvip.fangcuncl.com'
      || host === 'wxvip.swan0526.com'
    const defaultEntryPath = isZt260806Host ? '/act/zt260806' : '/act/zt260630'

    // 进入页立刻落盘，后续 URL 被改写也能从 sessionStorage 恢复（兼容 a_oId 等别名）
    const entryCallbackId = params.get('callbackid') || params.get('callbackId')
      || params.get('a_oId') || params.get('aOid') || ''
    if (entryCallbackId) {
      try {
        sessionStorage.setItem('landing_entry_callbackid', entryCallbackId)
        localStorage.setItem('last_aOid', entryCallbackId)
      } catch (e) {
        // ignore
      }
    }

    if (hash.startsWith('#/')) {
      const hashContent = hash.slice(2)
      const qIndex = hashContent.indexOf('?')
      const pathPart = qIndex >= 0 ? hashContent.slice(0, qIndex) : hashContent
      const queryPart = qIndex >= 0 ? hashContent.slice(qIndex + 1) : ''
      const hashPath = pathPart ? `/${pathPart.replace(/^\//, '')}` : '/'
      if (hashPath !== '/') {
        pathname = hashPath
      }
      if (queryPart) {
        new URLSearchParams(queryPart).forEach((value, key) => {
          if (!params.has(key)) {
            params.set(key, value)
          }
        })
      }
    }

    if (pathname.endsWith('/index4.html')) {
      pathname = defaultEntryPath
    }

    if ((pathname === '/' || pathname === '') && isZt260806Host) {
      pathname = defaultEntryPath
    }

    // /act/zt260806/ -> /act/zt260806，保留 ?callbackid=
    if (pathname.length > 1 && pathname.endsWith('/')) {
      pathname = pathname.replace(/\/+$/, '')
    }

    // 若 URL 已丢参，尝试从 sessionStorage 补回
    if (!(params.get('callbackid') || params.get('callbackId'))) {
      try {
        const cached = sessionStorage.getItem('landing_entry_callbackid') || ''
        if (cached) {
          params.set('callbackid', cached)
        }
      } catch (e) {
        // ignore
      }
    }

    const query = params.toString()
    const nextUrl = `${pathname}${query ? `?${query}` : ''}`
    const currentUrl = `${loc.pathname}${loc.search}${hash}`

    if (nextUrl !== currentUrl) {
      window.history.replaceState(null, '', nextUrl)
    }
  } catch (e) {
    // ignore
  }
}

normalizeEntryUrl()

async function bootstrap() {
  const routeConfig = await fetchLandingRouteConfig()
  const host = String(window.location.host || '').toLowerCase()
  if (host === 'wxvip.yingsi0221.com'
    || host === 'wxvip.fangcuncl.com'
    || host === 'wxvip.swan0526.com') {
    routeConfig.adEntryPath = '/act/zt260806'
    routeConfig.protectedDomains = Array.from(new Set([
      ...(routeConfig.protectedDomains || []),
      'wxvip.yingsi0221.com',
      'wxvip.fangcuncl.com',
      'wxvip.swan0526.com'
    ]))
    routeConfig.allowedPaths = Array.from(new Set([
      ...(routeConfig.allowedPaths || []),
      '/act/zt260806',
      '/pay-success'
    ]))
  }
  const { isAllowedPath, fallbackPath } = createRouteGuard(routeConfig)
  const routes = buildLandingRoutes(routeConfig, { ThirdPage, BlockedPage, fallbackPath })

  const router = new VueRouter({
    mode: 'history',
    routes
  })

  router.beforeEach((to, from, next) => {
    if (to.path === '/index4.html') {
      next({
        path: to.fullPath.includes('/pay-success') ? '/pay-success' : fallbackPath(),
        query: to.query,
        hash: to.hash,
        replace: true
      })
      return
    }

    // 尾斜杠统一到无斜杠路由，必须带上 query（callbackid）
    if (to.path.length > 1 && to.path.endsWith('/')) {
      next({
        path: to.path.replace(/\/+$/, ''),
        query: to.query,
        hash: to.hash,
        replace: true
      })
      return
    }

    if (!isAllowedPath(to.path) && to.path !== '/blocked') {
      next({ path: fallbackPath(), query: to.query, hash: to.hash, replace: true })
      return
    }

    next()
  })

  new Vue({
    router,
    render: h => h(App)
  }).$mount('#app')
}

bootstrap()
